// Utility to track and persist manual edit flags in localStorage

const STORAGE_KEY = 'metrica_manual_edits';

export interface ManualEditFlags {
  [expenseId: string]: {
    vendorName?: boolean;
    amount?: boolean;
    category1?: boolean;
    category2?: boolean;
    category3?: boolean;
    notes?: boolean;
    documentDate?: boolean;
    projectTag?: boolean;
  };
}

/**
 * Save manual edit flags for an expense
 */
export const saveManualEdits = (expenseId: string, flags: {
  vendorName?: boolean;
  amount?: boolean;
  category1?: boolean;
  category2?: boolean;
  category3?: boolean;
  notes?: boolean;
  documentDate?: boolean;
  projectTag?: boolean;
}) => {
  try {
    const existing = getManualEdits();
    existing[expenseId] = { ...existing[expenseId], ...flags };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
  } catch (error) {
    console.error('Error saving manual edits:', error);
  }
};

/**
 * Get manual edit flags for an expense
 */
export const getManualEdits = (): ManualEditFlags => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.error('Error reading manual edits:', error);
    return {};
  }
};

/**
 * Get manual edit flags for a specific expense
 */
export const getManualEditsForExpense = (expenseId: string) => {
  const allEdits = getManualEdits();
  return allEdits[expenseId] || {};
};

/**
 * Clear manual edit flags for an expense
 */
export const clearManualEdits = (expenseId: string) => {
  try {
    const existing = getManualEdits();
    delete existing[expenseId];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
  } catch (error) {
    console.error('Error clearing manual edits:', error);
  }
};

